import $ from "jquery";
import * as api from './api';
import * as render from './render';
import * as utils from './utils';
import tip from './tip';
import errorTip from "./errorTip";
import '../lib/swiper';
import '../scss/swiper.scss';

export const setGameList = async (defaultOptionValue) => {
  const gameListResponse = await api.getRequest('get_game_list');
  // +gameListResponse.result ? 
  //   render.setGame(gameListResponse.data.game_list) : 
  //   render.setGame([]);
  let params = {
    type: 'game',
    data: gameListResponse.data.game_list,
    defaultOptionValue: defaultOptionValue || '',
    selectClassName: 'j-game-select',
    defaultOptionInnerText: '請選擇遊戲',
    optionValue: 'game_id',
    optionInnerText: 'name'
  };
  +gameListResponse.result ?
    render.setSelectOptions(params) :
    render.setSelectOptions(params.data = [] && params);
  return Promise.resolve();
}

export const setServerList = async (defaultOptionValue) => {
  const serverResponse = await api.getRequest('list_server', {
    gameId: gameInfo.game.id
  });
  // await +serverResponse.result ? 
  //   render.setServer(serverResponse.data) : 
  //   render.setServer([]);
  let params = {
    type: 'server',
    data: serverResponse.data,
    defaultOptionValue: defaultOptionValue || '',
    selectClassName: 'j-server-select',
    defaultOptionInnerText: '請選擇伺服器',
    optionValue: 'id',
    optionInnerText: 'sname'
  };
  +serverResponse.result ?
    render.setSelectOptions(params) :
    render.setSelectOptions(params.data = [] && params);
  return Promise.resolve();
}

export const setRoleList = async (defaultOptionValue) => {
  const roleResponse = await api.getRequest('get_mobile_game_role', {
    game_id: gameInfo.game.id,
    server_id: gameInfo.server.sid
  });
  // +roleResponse.result ? render.setRole(roleResponse.data) : render.setRole([]);
  let params = {
    type: 'role',
    data: roleResponse.data,
    defaultOptionValue: defaultOptionValue || '',
    selectClassName: 'j-role-select',
    defaultOptionInnerText: '請選擇角色',
    optionValue: 'roleID',
    optionInnerText: 'roleName'
  };
  +roleResponse.result || (params.data = []);
  render.setSelectOptions(params);
  return Promise.resolve();
}


export const initSwiper = function () {
  const COMMON_CONFIG = {
    spaceBetween: 2,
    observer: true,
    observeParents: true,
    observeSlideChildren: true
  }
  window.activity.swiperAward = new Swiper('.part2 .swiper-container', {
    ...COMMON_CONFIG,
    slidesPerView: 4
  });
  window.activity.swiperGame = new Swiper('.part3 .swiper-container', {
    ...COMMON_CONFIG,
    slidesPerView: 3
  });
}

// 获取链接参数
const getPageDataFromURL = () => {
  let paramArr = ['gameId', 'game_id', 'serverId', 'loginName', 'loginAccount', 'sid', 'scid', 'role_id', 'roleId', 'roleName'];
  let paramMap = {};
  paramArr.forEach((item) => {
    paramMap[item] = utils.getParam(item);
  })
  return paramMap;
}

// 设置为已登录
const _setLogin = (userName) => {
  window.activity.login = true;
  render.setUserInfo(userName, true);
}

// 批量设置签到宝箱状态
const _loopSetBoxStatus = (day) => {
  if (day >= 4) {
    // console.log(1111);
    for (let i = 0; i < 4; i++) {
      render.setBoxStatus(i + 1, 'got');
    }
    return;
  }
  if (day < 1 || day > 3) {
    return;
  }
  for (let i = 0; i <= day; i++) {
    if (i == day) {
      render.setBoxStatus(i + 1, 'get');
      continue;
    }
    render.setBoxStatus(i + 1, 'got');
  }
}


// 数组中找元素
const _findArray = (array, key, value, returnValue) => {
  // console.log(array);
  for (let i = 0, length = array.length; i < length; i++) {
    if (array[i][key] == value) {
      return array[i][returnValue];
    }
  }
}

// 检查登录状态
const checkLogin = async () => {
  let userInfo = await api.checkLogin();
  if(userInfo.result == 1) {
    _setLogin(userInfo.data.LOGIN_ACCOUNT);
    // 上报上账号信息
    api.uploadPageInfo({account: userInfo.data.LOGIN_ACCOUNT});
  }
  // console.log(userInfo);
  // 弹窗登录弹窗
  // render.setTipPopup(tip.login);
  // render.showPopup('login')
  // render.setUserInfo('', false);
}

const updateBoxStatus = async (basicResponse) => {
  let signNum = +basicResponse.data.sign_num;
  basicResponse.data.is_award_sign_total && (signNum = 4);
  // 更新签到状态
  +basicResponse.result ?
    _loopSetBoxStatus(signNum) :
    render.errorHandler(basicResponse);
  // 更新按钮状态
  window.activity.signNum = +basicResponse.data.sign_num;
  if (!basicResponse.data.is_award_sign_total && basicResponse.data.sign_num == 3) {
    render.setSignBtn(2);
    return;
  }
  if (basicResponse.data.is_sign) {
    render.setSignBtn(0);
    return;
  }
  render.setSignBtn(1);
}

const updateGameInfo = async (basicResponse) => {
  // 没有绑定
  if (!basicResponse.data.bind_data) {
    render.setGameInfo(false);
    return;
  }
  // 已经绑定
  let { game_id, server_id, role_id } = basicResponse.data.bind_data;
  // 同步全局数据
  window.gameInfo.game.id = game_id;
  window.gameInfo.server.id = server_id;
  window.gameInfo.role.id = role_id;
  // 查找到游戏名，服务器名，角色名
  const gameInfoResponse = await Promise.all([
    api.getRequest('get_game_list'),
    api.getRequest('list_server', { gameId: game_id }),
    api.getRequest('get_mobile_game_role', { game_id: game_id, server_id: server_id })
  ]);
  let gameList = gameInfoResponse[0].data.game_list || [];
  let serverList = gameInfoResponse[1].data || [];
  let roleList = gameInfoResponse[2].data || [];
  let gameName = _findArray(gameList, 'game_id', game_id, 'name');
  let serverName = _findArray(serverList, 'sid', server_id, 'sname');
  let roleName = _findArray(roleList, 'roleID', role_id, 'roleName');
  // console.log(gameName, serverName, roleName);
  // 确定展示的角色ming
  render.setGameInfo(true, gameName, serverName, roleName);
}

export const init = async () => {
  window.SDK_PARAM = getPageDataFromURL();
  // console.log(window.SDK_PARAM);

  window.boolFromSDK = false;

  // 是否从SDK进入
  if ((SDK_PARAM.loginName || SDK_PARAM.loginAccount) &&
    (SDK_PARAM.gameId || SDK_PARAM.game_id) &&
    (SDK_PARAM.serverId || SDK_PARAM.sid) &&
    (SDK_PARAM.roleId || SDK_PARAM.role_id)) {
    boolFromSDK = true;
    window.gameInfo.game.id = SDK_PARAM.gameId || SDK_PARAM.game_id;
    window.gameInfo.server.id = SDK_PARAM.serverId || SDK_PARAM.sid;
    window.gameInfo.role.id = SDK_PARAM.roleId || SDK_PARAM.role_id;
    // console.log(window.gameInfo);
    render.hideStep3();
  }

  // console.log('fromSDK', boolFromSDK);
  if (boolFromSDK) {
    let account = SDK_PARAM.loginName || SDK_PARAM.loginAccount;
    _setLogin(account);
    api.uploadPageInfo({account});
    render.setAwardList(SDK_PARAM.gameId || SDK_PARAM.game_id);
  } else {
    checkLogin();
  }

  let basicResponse = await api.getRequest('basic');

  if (!boolFromSDK && basicResponse.data.bind_data) {
    render.setAwardList(basicResponse.data.bind_data.game_id);
  } else {
    render.setAwardList();
  }

  // 更新抽奖次数 && 更新签到时间  && 记录是否绑定了角色 
  if (+basicResponse.result) {
    let eggTime = basicResponse.data.bind_data ? basicResponse.data.lottery_times : 0;
    render.setEggTime(+eggTime, false);
    eggTime > 0 ?
      render.setGameStartStatus(false) :
      render.setGameStartStatus(true);
    render.setSignTime(basicResponse.data.sign_num);
    window.activity.boolBinded = !!basicResponse.data.bind_data;
  } else {
    render.setEggTime(0, false);
    render.setGameStartStatus(true);
    render.setSignTime(0);
    window.activity.boolBinded = !!basicResponse.data.bind_data;
  }
  // 更新签到箱子
  // const test = {
  //   "code": 1,
  //   "result": 1,
  //   "msg": "success",
  //   "data": {
  //     "is_award_sign_total": false,
  //     "sign_num": 0,
  //     "is_sign": true,
  //     "bind_data": {
  //       "game_id": "28",
  //       "server_id": "1575",
  //       "role_id": "X3BWsDP uUoWGwOa",
  //       "server_name": "s1-踏月留香",
  //       "role_name": "通恫侯"
  //     },
  //     "is_bind_phone": false,
  //     "lottery_times": 1
  //   }
  // }

  updateBoxStatus(basicResponse);
  // 绑定了直接展示绑定信息 && 更新抽奖机器的奖品列表
  updateGameInfo(basicResponse);
  
  // 没有绑定 && 已登录  要弹窗提示绑定  
  if (!(+basicResponse.result && basicResponse.data && basicResponse.data.bind_data) && window.activity.login) {
    if (boolFromSDK) {
      render.showPopup('select');
      await setGameList(SDK_PARAM.gameId || SDK_PARAM.game_id);
      await setServerList(SDK_PARAM.serverId || SDK_PARAM.sid);
      await setRoleList(SDK_PARAM.roleId || SDK_PARAM.role_id);
      return;
    }
    render.showPopup('select');
    await setGameList();
    await setServerList();
    await setRoleList();
  }

  // basicResponse.result == 0 ? 
}

// test
// window.render = render;








